import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
const THUMBNAIL_SIZE = 40;
const IMGX_OPTIONS = {
    fit: "crop",
    auto: "compress",
    cs: "origin",
    w: THUMBNAIL_SIZE,
    h: THUMBNAIL_SIZE
};
export const BoardThumbnail = (param)=>{
    let { thumbnails } = param;
    const fallbackUrl = useMemo(()=>{
        if (!!thumbnails && thumbnails.length) {
            return getCloudFrontUrlFromImgixUrl(thumbnails[0]);
        }
        return "";
    }, [
        thumbnails
    ]);
    if (!(thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length)) return null;
    return /*#__PURE__*/ _jsx(ImgixImage, {
        alt: "",
        fallbackUrl: fallbackUrl,
        imgixParams: IMGX_OPTIONS,
        height: THUMBNAIL_SIZE,
        src: thumbnails[0],
        width: THUMBNAIL_SIZE
    });
};
